/* ══════════════════════════════════════════════════════════════
   LORGAR PRODUCT TEMPLATE
   Quantity stepper and lore expander for the custom template.
   Gallery, variant picker and spec bars are handled by their own
   files. Load AFTER brutech-lorgar-product.js
══════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  function initQty(page) {
    var input = page.querySelector('#lg-qty-input');
    var out   = page.querySelector('#lg-qty-display');
    if (!input || !out) return;

    page.querySelectorAll('[data-lg-qty]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = parseInt(btn.getAttribute('data-lg-qty'), 10) || 0;
        var next = (parseInt(input.value, 10) || 1) + step;
        if (next < 1) next = 1;
        if (next > 99) next = 99;
        input.value = next;
        out.textContent = next;
      });
    });
  }

  function initLore(page) {
    var lore = page.querySelector('[data-lg-lore]');
    var btn  = page.querySelector('[data-lg-more]');
    if (!lore || !btn) return;

    /* Only offer the toggle if the content actually overflows */
    if (lore.scrollHeight <= lore.clientHeight + 8) {
      btn.hidden = true;
      lore.style.maxHeight = 'none';
      return;
    }

    btn.addEventListener('click', function () {
      var open = lore.classList.toggle('is-open');
      btn.textContent = open ? 'Show less ↑' : 'Read more ↓';
    });
  }

  function init() {
    try {
      document.querySelectorAll('[data-lg-page]').forEach(function (page) {
        if (page.dataset.lgReady) return;
        page.dataset.lgReady = '1';
        initQty(page);
        initLore(page);
      });
    } catch (e) {
      console.warn('[Brutech] LORGAR template:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  document.addEventListener('shopify:section:load', init);
})();
